export default [{
    icon: ['left', 'fal', 'cars'],
    text: 'Car',
    color: 'orange',
    value: 'car',
    crumb: ''
},
{
    icon: ['left', 'fal', 'truck-monster'],
    text: 'SUV',
    color: 'green',
    value: 'suv',
    crumb: ''
},
{
    icon: ['left', 'fal', 'truck-pickup'],
    text: 'Truck',
    color: 'purple',
    value: 'truck',
    crumb: ''
},
{
    icon: ['left', 'fal', 'shuttle-van'],
    text: 'Van/Minivan',
    color: 'yellow',
    value: 'van',
    crumb: ''
},
{
    icon: ['left', 'fal', 'balance-scale-right'],
    text: 'Not Sure',
    color: 'lime',
    value: 'not_sure',
    crumb: ''
}];